import type { FriendsOverview } from '@pixelworld/shared';
import { useCallback, useEffect, useState } from 'react';
import { fetchFriends } from './friends-api';

/** The player's friends, fetched now and every `refreshMs` while the page is open. */
export function useFriends(refreshMs: number): {
  overview: FriendsOverview | null;
  reload: () => void;
} {
  const [overview, setOverview] = useState<FriendsOverview | null>(null);
  const [version, setVersion] = useState(0);
  const reload = useCallback(() => setVersion((value) => value + 1), []);

  useEffect(() => {
    let active = true;
    const load = async () => {
      const result = await fetchFriends();
      // A failed refresh keeps the last list; the next one tries again.
      if (active && result.ok) setOverview(result.data);
    };
    void load();
    const timer = setInterval(() => void load(), refreshMs);
    return () => {
      active = false;
      clearInterval(timer);
    };
  }, [refreshMs, version]);

  return { overview, reload };
}
